import React from 'react';
import AssetListComponent from '../../../Components/AssetComponent/AssetListComponent';
import { useNavigate, useParams } from 'react-router-dom';

const AssetList = (props) => {
    let navigate = useNavigate();
    const params = useParams();

    return (
        <div>
            <AssetListComponent {...props} navigate={navigate} id={params.id} />
        </div>
    );
}

export default AssetList